import React from "react";

function SidebarNavItem({ active, onClick, title, subtitle, icon, collapsed = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={collapsed ? title : undefined}
      aria-label={collapsed ? title : undefined}
      className={`w-full text-left rounded-xl px-3 py-2 border transition ${
        active
          ? "bg-blue-50 border-blue-200 text-blue-900"
          : "bg-white border-slate-200 text-slate-800 hover:bg-slate-50"
      }`}
    >
      <div className={`flex items-center ${collapsed ? "justify-center" : "gap-2"}`}>
        {icon ? (
          <span className={`${active ? "text-blue-700" : "text-slate-500"} shrink-0`}>
            {icon}
          </span>
        ) : null}
        {collapsed ? (
          <span className="sr-only">{title}</span>
        ) : (
          <div className="min-w-0">
            <div className="text-sm font-semibold truncate">{title}</div>
            {subtitle ? (
              <div className="text-xs text-slate-500 mt-0.5 truncate">{subtitle}</div>
            ) : null}
          </div>
        )}
      </div>
    </button>
  );
}

export default SidebarNavItem;

